module.exports = __webpack_public_path__ + "static/media/Bagpiper.086e94a8.jpg";